<md-content-box class="lesson-block">
	<md-icon icon="untitled-ui/files/clipboard-check"></md-icon>
	<div class="lesson-block__body">
		<div class="lesson-block__header">
			<md-header size="xs">Surveys</md-header>
			@if (learnerLessonLink()) {
				<button
					md-button
					type="button"
					data-analytics="survey-copy-learner-link"
					md-tooltip="Copy a link to this lesson for the learner"
					(click)="copyLearnerLink()"
				>
					Copy Learner Link
				</button>
			}
		</div>

		<div class="lesson-block__content">
			@if (state.activeLearnerSurveys().length > 0) {
				<span class="survey-section-label md-text-xs-medium">Learner</span>
				@for (survey of state.activeLearnerSurveys(); track survey.surveyID) {
					<div class="survey-row">
						<span class="md-text-sm-regular">{{ survey.surveyName }}</span>
						<lb-survey-action
							[isAvailable]="state.surveyAvailable(survey)"
							[isSubmitted]="state.isSurveySubmitted(survey.surveyID)"
							[canSubmit]="isLearnerView()"
							(action)="openSurvey(survey, state.isSurveySubmitted(survey.surveyID))"
						></lb-survey-action>
					</div>
				}
			}

			@if (isLearnerView() && state.externalFeedbackSurveyUrl(); as feedbackUrl) {
				<p></p>
				<div class="survey-row">
					<p></p>
					<a md-button href="{{ feedbackUrl }}" target="_blank" rel="noopener noreferrer" data-analytics="survey-external-feedback">
						End of Course Survey
						<md-icon icon="untitled-ui/general/link-external-01"></md-icon>
					</a>
				</div>
			}

			@if (state.activeInstructorSurveys().length > 0) {
				<span class="survey-section-label md-text-xs-medium">Instructor</span>
				@for (survey of state.activeInstructorSurveys(); track survey.surveyID) {
					<div class="survey-row">
						<span class="md-text-sm-regular">{{ survey.surveyName }}</span>
						<lb-survey-action
							[isAvailable]="state.surveyAvailable(survey)"
							[isSubmitted]="state.isSurveySubmitted(survey.surveyID)"
							[canSubmit]="canSubmitInstructorSurvey()"
							(action)="openSurvey(survey, state.isSurveySubmitted(survey.surveyID))"
						></lb-survey-action>
					</div>
				}
			}
		</div>
	</div>
</md-content-box>
